import { render } from "./WebMenuBackground.vue?vue&type=template&id=557aaf05"
import script from "./WebMenuBackground.vue?vue&type=script&lang=js"
export * from "./WebMenuBackground.vue?vue&type=script&lang=js"

import "./WebMenuBackground.vue?vue&type=style&index=0&id=557aaf05&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__